import { z } from 'zod';

export const ZodVideoStreamControllerURLSourceConfiguration = z.object({
    url: z.string(),
});

export type VideoStreamControllerURLSourceConfiguration = z.infer<
    typeof ZodVideoStreamControllerURLSourceConfiguration
>;

export const ZodVLCVideoStreamControllerConfiguration = z.object({
    url: z.string(),
    aspect_ratio: z.string().nullish(),
    video_device: z.string().nullish(),
    vlc_options: z.string().nullish(),
});

export type VLCVideoStreamControllerConfiguration = z.infer<
    typeof ZodVLCVideoStreamControllerConfiguration
>;

export interface IVideoStreamController {
    readonly type: string;

    canBePlayed(): Promise<boolean>;

    getReadyForDisplay(): Promise<void>;

    pause(): Promise<void>;
    play(): Promise<void>;
    stop(): Promise<void>;
}

export function isIVideoStreamController(obj: unknown): obj is IVideoStreamController {
    return (
        obj instanceof Object &&
        'type' in obj &&
        typeof Reflect.get(obj, 'type') === 'string' &&
        'canBePlayed' in obj &&
        Reflect.get(obj, 'canBePlayed') instanceof Function &&
        'getReadyForDisplay' in obj &&
        Reflect.get(obj, 'getReadyForDisplay') instanceof Function &&
        'pause' in obj &&
        Reflect.get(obj, 'pause') instanceof Function &&
        'play' in obj &&
        Reflect.get(obj, 'play') instanceof Function &&
        'stop' in obj &&
        Reflect.get(obj, 'stop') instanceof Function
    );
}
